import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavLink } from '@welma-education/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wma-tabs-with-underline-horizontal',
  templateUrl: 'tabs-with-underline-horizontal.html',
  host: {
    class: 'block',
  },
  imports: [RouterLinkActive, RouterLink, TranslatePipe],
})
export class TabsWithUnderlineHorizontal {
  links = input<NavLink[]>([]);
}
